import * as React from "react";
import * as emoji from "emoji-dictionary";

export const emojiRenderer = (text: string) =>
  text.replace(/:\w+:/gi, (name: string) => emoji.getUnicode(name));

export const Emoji: React.StatelessComponent<{ name: string }> = ({ name }) => {
  return <span>{emoji.getUnicode(name)}</span>;
};
